<rt-attributes
  [translationsContext]="translationsContext"
  [canPick]="true"
  [canRemove]="true"
  [canCreate]="false"
  [toggle]="toggle"
  [attributes]="selectedAttributes"
  [suggestionsData]="suggestionsData"
  [listTpl]="triggerTemplate"
  [emitQueryOnStart]="false"
  (save)="onSave($event)"
  (query)="query.emit($event)"
>
</rt-attributes>
<ng-template #triggerTemplate let-context>
  <div
    #btn="rtOverlayOrigin"
    rt-overlay-origin
    (click)="!disabled && context.toggleDropdown(btn)"
    class="tags-container"
    layout-horizontal
    layout-align-items-center
    layout-space-between
  >
    @if (context.attributes.length === 0) {
      <span class="placeholder">
        {{ placeholder }}
      </span>
    }
    @if (context.attributes.length > 0) {
      <rt-group class="tag-container" layout-flex-1-1>
        @for (attr of $any(context.attributes); track trackById($index, attr)) {
          <rt-tag
            [name]="attr.value"
            [deletable]="true"
            [hasStopPropagation]="true"
            [disabled]="attr.processing"
            (deleteClick)="!disabled && deleteAttribute.emit(attr)"
            class="tag-container__tag"
            margin-tb-small-xx
          >
          </rt-tag>
        }
      </rt-group>
    }
    <div class="clear-all" layout-flex-0-0>
      @if (hasClearButton && selectedAttributes.length > 0) {
        <rt-icon-button
          variant="plain"
          iconName="close"
          size="small"
          (click)="handleClearAll($event)"
        >
        </rt-icon-button>
      }
    </div>
    <div class="arrow" [class.no-right-padding]="noRightPadding" layout-flex-0-0>
      <rt-icon [name]="context.dropdownOpened ? 'arrow-drop-up' : 'arrow-drop-down'" size="medium">
      </rt-icon>
    </div>
  </div>
</ng-template>
